import React, { Component } from 'react'

export default class Dropdown extends Component {
    constructor(props) {
        super(props)
    }
    
    render() {
        const {label, require, name, value,disable,fpgerror,id, DefaultOption} = this.props
        const options = this.props.options && this.props.options.map(function(option) {
            return (
                <option key={option} value={option}>{option}</option>
            )
        })
        return (
            <div className="field_row_inner">
                {label ? <label className={`${require ? 'required' : null}`}>{label}</label> : "" }
                <div className="select_field relative" style={{width: name === 'influencedCamera' && '300px'}} >
                    <select disabled={disable} name={name} onChange={(e) => this.props.onChange(e, id)} value={value}>
                    {DefaultOption && <option disabled selected value=''>{DefaultOption}</option>}
                        {options}
                    </select>
                    {fpgerror ? <span style={{ color: 'red' }}>{fpgerror}</span> : ''}
                </div>
            </div>
        )
    }
}
